import { applyTilesetAutotileAtWorld } from '../../shared/TilesetAutotiles'
import { getTilesetDef } from '../../shared/Tilesets'
import { LayerOrders, LayerNames } from '../../shared/shared'

import { TileLayer } from '../TileLayer'

export class ClientTiles {
  constructor(world) {
    this.world = world
    this.terrain = new TileLayer(world.scene, world.tileAtlas, world.lights, {
      z: LayerOrders.TERRAIN,
      ySort: false,
    })
    this.decor = new TileLayer(world.scene, world.tileAtlas, world.lights, {
      z: LayerOrders.DECOR,
      ySort: false,
    })
    this.objects = new TileLayer(world.scene, world.tileAtlas, world.lights, {
      z: LayerOrders.OBJECT,
      ySort: true,
    })
    this.overlay = new TileLayer(world.scene, world.tileAtlas, world.lights, {
      z: LayerOrders.OVERLAY,
      ySort: false,
    })
  }

  getStateAt(x, y, layer) {
    const chunk = this.world.chunks.getAtWorld(x, y)
    return chunk?.getTileStateAtWorld(x, y, layer) || null
  }

  applyTilesetAutotileAt(tilesetId, presetId, x, y) {
    const preset = getTilesetDef(tilesetId)?.presets?.[presetId]
    if (!preset) return []
    const { layer } = preset
    const getEntry = (wx, wy) => {
      const chunk = this.world.chunks.getAtWorld(wx, wy)
      return chunk?.getTileStateAtWorld(wx, wy, layer) ?? null
    }
    return applyTilesetAutotileAtWorld(tilesetId, presetId, x, y, {
      getEntryAtWorld: getEntry,
      setTileDescAtWorld: (wx, wy, desc) => this.setTileDescAt(wx, wy, desc),
    })
  }

  setTileDescAt(x, y, desc) {
    const chunk = this.world.chunks.getAtWorld(x, y)
    return chunk?.setTileDescAtWorld(x, y, desc) || false
  }

  clearAt(x, y, layer) {
    const chunk = this.world.chunks.getAtWorld(x, y)
    return chunk?.clearTileAtWorld(x, y, layer) || false
  }

  setVisual(layer, x, y, key, fps = 0, yBase = 0) {
    this[LayerNames[layer]]?.set(x, y, key, fps, yBase)
  }

  clearVisual(layer, x, y) {
    this[LayerNames[layer]]?.clear(x, y)
  }

  update(delta, time) {
    this.terrain.update(delta, time)
    this.decor.update(delta, time)
    this.objects.update(delta, time)
    this.overlay.update(delta, time)
  }
}
